// extracted by mini-css-extract-plugin
export default {"banner":"SMRBanner_banner__i5Ggr","leftIcon":"SMRBanner_leftIcon__VnhYq"};